import { ApiRoutes, QueryError } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { PageComponent, PageComponentsFormFields, PageComponentsQueryKeys } from '@/modules/Pages';

export const useGetByIdComponentsPageQuery = (componentId: string, siteId: string) =>
  buildQuery<PageComponent, QueryError>([PageComponentsQueryKeys.GetOneById, siteId, componentId], async () => {
    const { data } = await apiExecutor.get<PageComponent>(
      ApiRoutes.PageComponentsById.replace(':siteId', siteId).replace(':componentId', componentId)
    );
    return data;
  });

export const useGetComponentsPageQuery = (siteId: string) =>
  buildQuery<PageComponent[], QueryError>([PageComponentsQueryKeys.GetAll, siteId], async () => {
    const { data } = await apiExecutor.get<PageComponent[]>(
      ApiRoutes.PageComponents.replace(':siteId', siteId)
    );
    return data;
  });

export const useCreateComponentsPageMutation = (siteId: string) =>
  buildMutation<PageComponent, QueryError, PageComponentsFormFields>([PageComponentsQueryKeys.Create, siteId], async (postData) => {
    const { data } = await apiExecutor.post<PageComponent>(ApiRoutes.PageComponents.replace(':siteId', siteId), {
      ...postData, siteId
    });
    return data;
  });

export const useEditComponentsPageMutation = (id: string, siteId: string) =>
  buildMutation<PageComponent, QueryError, PageComponentsFormFields>([PageComponentsQueryKeys.Edit, siteId, id], async (postData) => {
    const { data } = await apiExecutor.patch<PageComponent>(
      ApiRoutes.PageComponentsById.replace(':siteId', siteId).replace(':componentId', id),
      { ...postData, siteId, id }
    );
    return data;
  });

export const useDeleteComponentsPageMutation = (id: string, siteId: string) =>
  buildMutation<void, QueryError, void>([PageComponentsQueryKeys.Delete, siteId, id], async () => {
    await apiExecutor.delete<PageComponent>(
      ApiRoutes.PageComponentsById.replace(':siteId', siteId).replace(':componentId', id)
    );
  });

export const useBreadcrumbPageComponentQuery = (id: string, siteId: string) =>
  buildQuery<string, QueryError>([PageComponentsQueryKeys.Breadcrumb, siteId, id], async () => {
    const { data } = await apiExecutor.get<string>(
      ApiRoutes.PageComponentsBreadcrumb.replace(':siteId', siteId).replace(':componentId', id)
    );
    return data;
  });

export const useAutocompletePageComponentsQuery = (siteId: string) =>
  buildQuery<Pick<PageComponent, 'id' | 'name'>[], QueryError>([PageComponentsQueryKeys.Autocomplete, siteId], async () => {
    const { data } = await apiExecutor.get<Pick<PageComponent, 'id' | 'name'>[]>(ApiRoutes.PageComponentsAutocomplete.replace(':siteId', siteId), {});
    return data;
  });
